import ApolloConfigurationStateMonitor from 'components/state-monitors/ApolloConfigurationStateMonitor';

/**
 * Redux state monitors are pure-logic components or hooks that monitor the state of some
 * bit of the redux store, possibly through selectors or other logic, and
 * respond with some appropriate action whenever that bit of the store changes.
 * Their code logically lives with the particular feature, but they need to be
 * installed exactly once somewhere near the root of the React tree where
 * they'll always be running.
 *
 * This component is the umbrella where they can all live. If you write a new
 * redux state monitor, add it as a child of this component rather than adding
 * it to Application.tsx or some local component. This ensures that the monitors
 * are easy to find and installed in the app correctly.
 */
export default function ReduxStateMonitors() {
  return (
    <>
      <ApolloConfigurationStateMonitor />
    </>
  );
}
